import moment from "moment";

const UserAdministrationValidator = (t) => {
  moment.locale("es");
  let regexs = {
    emailRegex: new RegExp(/^[a-zA-ZñÑ0-9._-]+@([a-zA-Z0-9._-]+\.)+[\w-]{2,}$/),
  };

  let validators = {
    emailValidator: (value) => {
      if (value !== "" && value !== undefined) {
        if (value.length > 0) {
          return regexs.emailRegex.test(value)
            ? ""
            : t("signature.request.emailValidator");
        }
      } else {
        return t("signature.request.emailValidatorNull");
      }
    },
  };
  return validators;
};

export default UserAdministrationValidator;
